__turbopack_context__.v({
  "active": "jWJS8W_active",
  "desktopNavigation": "jWJS8W_desktopNavigation",
  "glossaryNavigationItem": "jWJS8W_glossaryNavigationItem",
  "glossaryNavigationPanel": "jWJS8W_glossaryNavigationPanel",
  "link": "jWJS8W_link",
  "mobileNavigation": "jWJS8W_mobileNavigation",
});
